import React, { FC, Fragment } from 'react';
import ButtonBase from '@material-ui/core/ButtonBase';
import { IconHolder, NextButton } from '../Buttons/Buttons';
import { useStyles } from './menu.style';
import { Link } from 'react-router-dom';
import { CommonButtonTypes } from 'Common/Types/Types';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Grid from '@material-ui/core/Grid';

interface MenuProps extends CommonButtonTypes {
	width?: string;
	url: string;
	type: string;
	no?: number | undefined;
	image: string;
	description?: string;
	link?: string | undefined;
	icon?: string | undefined;
	isMenu?: boolean;
	isUpcoming?: boolean;
	isCategory?: boolean;
	budge?: any;
	onClick?:any;
	externalLink?:any;
}
const MenuCard = ({
	url,
	type,
	description,
	image,
	icon,
	isMenu,
	common,
	isUpcoming,
	budge,
	isCategory,
	no,
	onClick,
	externalLink
}: MenuProps) => {
	const classes = useStyles({ common });
	const matches = useMediaQuery('(max-width:768px)');
	// eslint-disable-next-line no-console
	console.log(typeof no)
	return (
		<Fragment>
			<div className={classes.root}>
				<section onClick={() => onClick(url,externalLink)} className={classes.links}>
					<ButtonBase focusRipple className={classes.image}>
						<span
							className={classes.imageSrc}
							style={{
								backgroundImage: `url(${image})`,
								margin: `${matches ? '1rem auto auto' : 'initial'}`,
							}}
						/>
						<div
							className={`${classes.mainCard} d-flex flex-no-wrap justify-content-between w-100 align-items-center mx-4 my-2`}
						>
							<aside className={`${classes.elements} d-flex flex-nowrap align-items-center`}>
								{isMenu && <IconHolder common={{ icon: icon }} />}
							</aside>
							{isCategory && (
								<img
									src={icon}
									alt=""
									style={{ position: 'absolute', left: '-40px' }}
									className={classes.hideShowSideIconMobile}
								/>
							)}
							<div
								className={`${classes.cardSize} d-flex flex-no-wrap justify-content-between w-100 align-items-center`}
							>
								<Grid container alignItems="baseline" item xs="auto" spacing={3}>
									{ !isMenu && isUpcoming &&
									<Grid item xs={12}>
										<p className={classes.description}>{type}</p>
									</Grid>}
									{!isUpcoming && (
										<div className={classes.description}>
											<Grid item   xs={matches ?  12 : 3}>
												<h3
													className={classes.type}
													style={{ paddingLeft: !isMenu ? '3rem' : matches ? '' : '2rem', textAlign: matches ? 'center' :  'left' }}
												>
													{type}
												</h3>
											</Grid>
											{no === undefined ?  
											(
												''
												// <Grid item xs={matches ?  12 : 3}>
												// 	<h3
												// 		className={classes.numberOfUpcoming}
												// 		style={{ paddingLeft: !isMenu ? '3rem' : '' }}
												// 	>
												// 		{no === 0 ? `completed`: `${no} upcoming`} 
												// 	</h3>
												// </Grid>
											)
											: (
												<Grid item xs={matches ?  12 : 3}>
													<h3
														className={classes.numberOfUpcoming}
														style={{ paddingLeft: !isMenu ? '3rem' : '' }}
													>
														{no === 0 ? `Completed`: `${no} upcoming`} 
													</h3>
												</Grid>
											)} 
											<Grid item xs={8} >
												<h3
													className={`${classes.description}`}
													style={{
														textAlign: matches ? 'center' :'left',
														justifyContent: `${no === 0 ? 'flex-start' : 'flex-start'}`,
														paddingRight:matches ? '' :  '2rem',
													}}
												>
													{description}
												</h3>
											</Grid>
										</div>
									)}
								</Grid>
							</div>
							<aside className={classes.elements}>
								{isUpcoming ? (
									<img src={budge} alt="" />
								) : (
									<div className={classes.hideNextButton}>
										<NextButton
											common={{
												width: '49px',
												height: '48px',
												roundSvgBackground: 'white',
												arrowSvgColor: '#78393D',
											}}
										/>
									</div>
								)}
							</aside>
						</div>
					</ButtonBase>
				</section>
			</div>
		</Fragment>
	);
};

export default MenuCard;
